import {
  MITSUI_ORG_CODE,
  MITSUI_HIDDEN_CALCULATION_ITEM_NAMES,
  MITSUI_VISIBLE_SEND_PARAMS,
  ORG_999_CODE,
  ORG_999_HIDDEN_CALCULATION_ITEM_NAMES,
} from './org'

// 判定に必要な算出項目の最小情報（name: 日本語項目名 / sendParameterName: 送信パラメータ名）
type CalculationItemIdentity = {
  name: string
  sendParameterName: string
}

// 組織コードごとの非表示算出項目名のマッピング
const HIDDEN_CALCULATION_ITEMS_MAP: Record<string, string[]> = {
  [MITSUI_ORG_CODE]: MITSUI_HIDDEN_CALCULATION_ITEM_NAMES,
  [ORG_999_CODE]: ORG_999_HIDDEN_CALCULATION_ITEM_NAMES,
}

// 組織コードと項目名に基づいて、非表示にすべき算出項目かどうかを判定する共通関数
export const isHiddenCalculationItem = (
  orgCode: string,
  itemName: string
): boolean => {
  const hiddenItems = HIDDEN_CALCULATION_ITEMS_MAP[orgCode]
  if (!hiddenItems) return false
  return hiddenItems.includes(itemName)
}

// 組織コードごとの「表示する」項目の sendParameterName マッピング
// 対象orgや項目を増やす場合はこのマップに追加する
// NOTE: 988は三井系だが app で全14項目を入力し縦計算(precheck)もその全項目を参照するため、
//       3項目に絞ると確定時の縦計算が合わなくなる。対象は007のみとする。
// NOTE: 項目名（日本語）ではなく sendParameterName で識別する（DSL変更による表記ゆれに強い）
const VISIBLE_SEND_PARAMS_MAP: Record<string, string[]> = {
  [MITSUI_ORG_CODE]: MITSUI_VISIBLE_SEND_PARAMS,
}

// 「非表示か」の統合判定。
// VISIBLE_SEND_PARAMS_MAP に登録されたorgは sendParameterName が visible に無ければ非表示、
// それ以外のorgは従来の非表示項目名判定（isHiddenCalculationItem・項目名ベース）にフォールバックする。
// NOTE: 日次精査画面（tenantSalesReport）・売上報告タブ一覧（SalesReportsTab）で使用。
export const isHiddenCalculationItemByPolicy = (
  orgCode: string,
  calculationItem: CalculationItemIdentity
): boolean => {
  const visibleSendParams = VISIBLE_SEND_PARAMS_MAP[orgCode]
  if (visibleSendParams) {
    return !visibleSendParams.includes(calculationItem.sendParameterName)
  }
  return isHiddenCalculationItem(orgCode, calculationItem.name)
}
